


























































































import { Vue, Component, Prop } from 'vue-property-decorator';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import Review from '~/components/lists/items/Review.vue';
import AllRatingsModal from '~/components/modals/AllRatingsModal.vue';
import RatingKpis from '~/components/partials/RatingKpis.vue';
import WriteReviewModal from '~/components/modals/WriteReviewModal.vue';

const Modal = {
  ALL_RATINGS: 'all-ratings',
  WRITE_REVIEW: 'write-review',
};

@Component({
  components: {
    ChevronRightSolid,
    Review,
    AllRatingsModal,
    RatingKpis,
    WriteReviewModal,
  },
})
export default class ReviewsFeed extends Vue {
  @Prop(Array) ratings: [];
  @Prop(Boolean) isLoading: false;

  Modal = Modal;
  modal: string = '';

  /* Returns user connection status */
  get checkUserConnection () {
    return this.$cookies.get('token');
  }

  /* Calculates the average note of ratings */
  get averageRatesNote () {
    if (this.ratings) {
      let sum: number = 0;
      /* eslint array-callback-return: 0 */
      this.ratings.map((r: any) => {
        sum += r.note;
      });
      return sum / this.ratings.length;
    }
    return null;
  }

  /* If route contains openWriteModal query, then we automatically display modal */
  mounted () {
    if (this.$route.query?.openWriteModal) {
      this.modal = Modal.WRITE_REVIEW;
    }
  }
}
